import { render, staticRenderFns } from "./Pzns.vue?vue&type=template&id=7a1b8080"
import script from "./Pzns.vue?vue&type=script&lang=js"
export * from "./Pzns.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports